import { gql } from '@apollo/client'

export const warehouseQuery = gql`
  query getCurrentWarehouse($input: CurrentWarehouseInput!) {
    getCurrentWarehouse(input: $input)
  }
`

// same query as above, but for more clarity in the devtools
export const warehouseCartQuery = gql`
  query getWarehouseForCart($input: CurrentWarehouseInput!) {
    getCurrentWarehouse(input: $input)
  }
`
